import { styled } from '@mui/material/styles';

import { BRAND } from '../../shared/theme/paletteDark';
import { FONTS } from '../../shared/theme/typography';

/** The travel section's two buttons: Set home, and the underlined text links beside it. */

export const PickerButton = styled('button')({
  appearance: 'none',
  border: `1px solid ${BRAND.parchment}`,
  borderRadius: 999,
  padding: '7px 16px',
  background: BRAND.parchment,
  color: BRAND.mocha,
  fontFamily: FONTS.body,
  fontSize: 13,
  fontWeight: 700,
  cursor: 'pointer',
  '&:disabled': { opacity: 0.4, cursor: 'default' },
  '&:focus-visible': { outline: `2px solid ${BRAND.parchment}`, outlineOffset: 2 },
});

export const TextButton = styled('button')({
  appearance: 'none',
  background: 'none',
  border: 'none',
  padding: 0,
  fontFamily: FONTS.body,
  fontSize: 12.5,
  fontWeight: 700,
  color: 'rgba(243,238,231,0.8)',
  textDecoration: 'underline',
  textUnderlineOffset: 3,
  cursor: 'pointer',
  '&:hover': { color: BRAND.parchment },
  '&:disabled': { opacity: 0.4, cursor: 'default' },
});

/** A labelled field in the home picker and the map's popover: small caps-ish label over its input. */
export const Field = styled('div')({
  display: 'block',
  marginBottom: 10,
  fontFamily: FONTS.body,
  fontSize: 11.5,
  fontWeight: 700,
  letterSpacing: '0.02em',
  color: 'rgba(243,238,231,0.7)',
});

export const inputStyle = {
  display: 'block',
  width: '100%',
  boxSizing: 'border-box',
  marginTop: 5,
  padding: '8px 12px',
  borderRadius: 10,
  border: '1px solid rgba(243,238,231,0.45)',
  background: 'rgba(243,238,231,0.06)',
  color: BRAND.parchment,
  fontFamily: FONTS.body,
  fontSize: 14,
  fontWeight: 500,
  outline: 'none',
  '&:focus': { borderColor: BRAND.parchment },
} as const;
